module.exports = __webpack_public_path__ + "static/media/icon_157.ed7027e4.svg";